import { render, staticRenderFns } from "./HistorialEmergenciasPage.vue?vue&type=template&id=38d16258&"
import script from "./HistorialEmergenciasPage.vue?vue&type=script&lang=js&"
export * from "./HistorialEmergenciasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports